// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3uZO6","selects":"Documents_selects__1sn9v"};